(function ($) {
	$(document).ready(function () {
		$(".video-link").magnificPopup({
			type: "iframe",
			gallery: {
				enabled: true,
			},
		});
	});
})(jQuery);
